const statuses = [
  { status: 'Open', translattedStatus: 'Submitted' },
  { status: 'Re-Opened', translattedStatus: 'Submitted' },
  { status: 'Pending Adjustment - Member Action', translattedStatus: 'Submitted' },
  { status: 'Limits Applied', translattedStatus: 'Submitted' },
  { status: 'Notification', translattedStatus: 'Draft' },
  { status: 'Draft', translattedStatus: 'Draft' },
  { status: 'Cancelled', translattedStatus: 'Cancelled' },
  { status: 'Finalised', translattedStatus: 'Finalised' },
];

const mapToDefaultIfNull = (field, defaultValue) => {
  if (!field) {
    return defaultValue;
  }
  return field;
};

const statusMapper = {
  map(originalStatus) {
    const newStatuses = statuses.filter((status) => status.status.toLowerCase() === originalStatus.toLowerCase());
    if (!newStatuses || newStatuses.length < 1) {
      return 'Closed';
    }
    return newStatuses[0].translattedStatus;
  },
};

export const clientInfoMapper = {
  map(clientInfo) {
    return {
      title: mapToDefaultIfNull(clientInfo.title, ''),
      firstName: mapToDefaultIfNull(clientInfo.firstName, ''),
      surname: mapToDefaultIfNull(clientInfo.surname, ''),
      dateOfBirth: mapToDefaultIfNull(clientInfo.dateOfBirth, ''),
      addressLine1: mapToDefaultIfNull(clientInfo.addressLine1, ''),
      addressLine2: mapToDefaultIfNull(clientInfo.addressLine2, ''),
      stateProvinceRegion: mapToDefaultIfNull(clientInfo.state, ''),
      postalZipCode: mapToDefaultIfNull(clientInfo.postalCode, ''),
      mobile: mapToDefaultIfNull(clientInfo.mobilePhone, ''),
      homePhone: mapToDefaultIfNull(clientInfo.homePhone, ''),
      workPhone: mapToDefaultIfNull(clientInfo.workPhone, ''),
      email: mapToDefaultIfNull(clientInfo.email, ''),
      occupation: mapToDefaultIfNull(clientInfo.occupation, ''),
      policyNumber: mapToDefaultIfNull(clientInfo.policyNumber, ''),
    };
  },
};

export const mapBenefitCodeToAttachments = (benefitCodeList, attachmentList) => {
  const tmp = [...attachmentList];
  const tmp1 = [...benefitCodeList];

  for (let x = 0; x < tmp1.length; x++) {
    if (!tmp1[x].benefitCode) {
      tmp1[x].benefitCode = '-1';
    }
  }
  for (let i = 0; i < tmp.length; i++) {
    const rs = benefitCodeList.filter((m) => m.id === tmp[i].id);
    if (rs.length) {
      tmp[i].benefitCode = rs[0].benefitCode;
    }
  }
  return tmp;
};

export function mapDataFromOldFnol(data, isSubmitted, selectedClaimTypes, newVersion) {
  // TODO
  // set visited step 0
  // if submitted set selected benefit all
  // set validator true if submitted
  // if not submit set validator to false
  // remap data
  const result = Object.assign({}, data);
  if (newVersion) {
    if ((typeof (data.stepWhatHappenedData.selectedBenefits)) !== 'undefined') {
      return data;
    }
    if (isSubmitted || (!!data.stepWhatHappenedData.dateOfEvent && !!data.stepWhatHappenedData.timeOfEvent)) {
      result.stepWhatHappenedData.selectedBenefits = selectedClaimTypes;
    }
  } else {
    if ((typeof (data.step5Data.selectedBenefits)) !== 'undefined') {
      return data;
    }
    if (isSubmitted || (!!data.step5Data.dateOfEvent && !!data.step5Data.timeOfEvent)) {
      result.step5Data.selectedBenefits = selectedClaimTypes;
    }
  }

  result.visitedStep = 0;
  for (let x = 0; x < result.steps.length; x++) {
    result.steps[x].error = false;
    result.steps[x].dirty = false;
  }
  return result;
}


export default statusMapper;



// WEBPACK FOOTER //
// ./app/containers/ClaimList/dataMapper.js